module.exports = __webpack_public_path__ + "static/media/application-presentation.e1eede1a.svg";